import { feedbackcard, YesObject } from '@yes.technology/react-toolkit'
import { resolveQuery } from 'filteraction/FilteractionResolver'
import isEmpty from 'lodash/isEmpty'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { FieldValues } from '../../../types'
import { operators } from '../../Operators/operators.constants'

type UseFieldResolveFilterQueryParams = {
  name?: string
  fieldValues: FieldValues
  handleChange?: (value: FieldValues) => void
}

export const useFieldResolveFilterQuery = ({
  name,
  fieldValues,
  handleChange
}: UseFieldResolveFilterQueryParams) => {
  const { t } = useTranslation()

  const onResolveFilterQuery = useCallback(async () => {
    if (!name) {
      return
    }
    const inputValue = String(fieldValues[name]?.value) || ''

    try {
      const resolvedQuery = await resolveQuery(
        {
          $filteraction: inputValue
        },
        console.log,
        [],
        true,
        true,
        (objects) => objects.map((object: YesObject) => object)
      )

      if (
        resolvedQuery &&
        !isEmpty(resolvedQuery) &&
        Object.keys(resolvedQuery).some((op) => ['$in', '$nin'].includes(op))
      ) {
        const [[op, values]] = Object.entries(resolvedQuery) as [
          string,
          YesObject[]
        ][]

        const operatorObject = Object.values(operators)
          .flat()
          .find((o) => o?.operator === op.replace('$', ''))

        if (operatorObject?.operator) {
          handleChange?.({
            [name]: {
              ...fieldValues[name],
              value: values.map((option) => ({
                uuid: option?.uuid,
                des: option?.des || option?.code || ''
              })) as FieldValues['']['value'],
              operator: operatorObject.operator
            }
          })
        }
      }
    } catch (error) {
      console.error('Error fetching filteraction', error)
      feedbackcard(t('generic-error'), {
        type: 'error',
        message: t('filter-fields.invalid-filter-action-format')
      })
    }
  }, [name, fieldValues, handleChange, t])

  return { onResolveFilterQuery }
}
